module.exports = 'react-ansi-style-';



//////////////////
// WEBPACK FOOTER
// C:/Work/repo/metabase/metabase_wh/node_modules/react-ansi-style/default-css-prefix.js
// module id = 1127
// module chunks = 7